import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AlertService } from './components/alert/alert.service';
import { OnlineHelpService } from './components/online-help/online-help.service';
import { SidenavService } from './components/sidenav/sidenav.service';
import { IDashboardOperationRequest } from './modules/shared/models/operation.model';
import { EDashboardStatus } from './pages/dashboard/dashboard.constants';
import { DashboardService } from './pages/dashboard/dashboard.service';
import { AuthenticationService } from './services/authentication.service';
import { LoggerService } from './services/logger.service';
import { SpinnerService } from './services/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  destroy$ = new Subject();

  constructor(
    private readonly _sidenavService: SidenavService,
    private readonly _spinner: SpinnerService,
    private readonly _router: Router,
    private readonly _onlineHelpService: OnlineHelpService,
    private readonly _alertService: AlertService,
    private readonly _dashboardService: DashboardService,
    private readonly _authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.watchRouterEvents();
    //  if (this._authService.visibilityMode === EUserVisibility.F) { // TODO && this._authService.dashboardMode === EUserVisibility.F) {
      this.watchPendingOperations();
    //  }
  }

  get isSidenavOpened(): boolean {
    return this._sidenavService.opened;
  }

  get spinnerActive(): boolean {
    return this._spinner.active;
  }

  get isOnlineHelpSidenavOpened(): boolean {
    return this._onlineHelpService.opened;
  }

  toggle(): void {
    if (this.isSidenavOpened) {
      this.toggleSidenav()
    } else if (this.isOnlineHelpSidenavOpened) {
      this.toggleOnlineHelpSidenav()
    }
  }

  toggleSidenav() {
    this._sidenavService.toggle();
  }

  toggleOnlineHelpSidenav(): void {
    this._onlineHelpService.toggle();
  }

  watchRouterEvents() {
    this._router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          LoggerService.logInfo(this.constructor.name, 'watchRouterEvents');
          window.scrollTo(0, 0);
        }
      });
  }

  watchPendingOperations() {
    this._dashboardService.pendingOperationSub
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        LoggerService.logInfo(this.constructor.name, 'watchPendingOperations');
        this.checkPendingOperations();
      })
  }

  checkPendingOperations(): void {
    this._spinner.show();
    const body: IDashboardOperationRequest = {
      userId: this._authService.loggedUser.matricola,
      operationStatus: [EDashboardStatus.DRAFT, EDashboardStatus.TO_UPLOAD]
    }
    LoggerService.logInfo(this.constructor.name, 'checkPendingOperations', { body });
    this._dashboardService.getDashboardOperations(body)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: resp => {
          LoggerService.logInfo(this.constructor.name, 'checkPendingOperations', { resp });
          this._dashboardService.notifyPendingOperations(resp.data && resp.data.length > 0);
          this._spinner.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'checkPendingOperations', { error });
          this._alertService.openErrorMessage('', 'checkPendingOperations', error);
          this._spinner.hide();
        }
      })
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
